import React from 'react';

const Checkbox = props => {
    const { className, name, label, allowLabelHtml, register, ...rest } = props;
    let labelContent;
    if (allowLabelHtml) {
        labelContent = <span dangerouslySetInnerHTML={{ __html: label }}></span>;
    } else {
        labelContent = label;
    }

    const classN = className ? className : 'app__custom-checkbox';

    return (
        <div className={`${classN}`}>
            <label className={`${classN}__input`}>
                <input type="checkbox" name={name} {...register} {...rest} />
                {labelContent}
            </label>
        </div>
    );
};

export default Checkbox;
